var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lx-input-wrap",class:[
  `lx-input-${_vm.size}`,
  _vm.round ? `lx-input-${_vm.size}-round` : '',
  `lx-input${_vm.disabled ? '-disabled' : ''}`,
  `lx-input-style-${_vm.defaultStyle}`,
],style:([
  {
    '--width': _vm.width,
    '--height': _vm.height,
    '--left': _vm.isPrefix && _vm.defaultStyle === 'first' ? '15px' : 0,
    '--right': _vm.isSuffix ? '15px' : 0,
  },
])},[(_vm.isPrefix)?_vm._t("prefix"):_vm._e(),_c('input',{staticClass:"lx-input lx-flex-grow-1",attrs:{"id":_vm.id,"type":_vm.type,"name":_vm.name,"src":_vm.src,"min":0,"autofocus":_vm.autofocus,"maxlength":_vm.maxlength,"minlength":_vm.minlength,"disabled":_vm.disabled,"autocomplete":_vm.autocomplete,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"blur":_vm.onBlur,"change":_vm.onChange,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.onKeyup.apply(null, arguments)},"paste":_vm.onPaste}}),(_vm.isSuffix)?_vm._t("suffix"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }